import { dataUndoSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUndoSolid = /*#__PURE__*/createIcon(dataUndoSolid)
export default IconUndoSolid
